/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_1 = 'http://10.50.16.213:40001/mock/283' as any;
const devUrl_0_0_0_1 = '' as any;
const prodUrl_0_0_0_1 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_1 = 'retdata' as any;

/**
 * @分类 [mock数据属性管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2004)
 * @请求头 `GET /api/dataProperty/list-by-device-type-rules-id`
 */
export interface DataPropertyListByDeviceTypeRulesIdGetRequest {
  /**
   * 设备类目Id
   */
  deviceTypeId: string;
  /**
   * 规则Id
   */
  rulesId: string;
}

/**
 * @分类 [mock数据属性管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2004)
 * @请求头 `GET /api/dataProperty/list-by-device-type-rules-id`
 */
export type DataPropertyListByDeviceTypeRulesIdGetResponse = {
  /**
   * 主键
   */
  id?: number;
  /**
   * 名称
   */
  name?: string;
}[];

/**
 * @分类 [mock数据属性管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2004)
 * @请求头 `GET /api/dataProperty/list-by-device-type-rules-id`
 */
type ApiDataPropertyListByDeviceTypeRulesIdGetRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/dataProperty/list-by-device-type-rules-id',
    'retdata',
    string,
    'deviceTypeId' | 'rulesId',
    false
  >
>;

/**
 * @分类 [mock数据属性管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2004)
 * @请求头 `GET /api/dataProperty/list-by-device-type-rules-id`
 */
const apiDataPropertyListByDeviceTypeRulesIdGetRequestConfig: ApiDataPropertyListByDeviceTypeRulesIdGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/api/dataProperty/list-by-device-type-rules-id',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: ['deviceTypeId', 'rulesId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDataPropertyListByDeviceTypeRulesIdGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * @分类 [mock数据属性管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2004)
 * @请求头 `GET /api/dataProperty/list-by-device-type-rules-id`
 */
export const apiDataPropertyListByDeviceTypeRulesIdGet = /*#__PURE__*/ (
  requestData: DataPropertyListByDeviceTypeRulesIdGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<DataPropertyListByDeviceTypeRulesIdGetResponse>(
    prepare(apiDataPropertyListByDeviceTypeRulesIdGetRequestConfig, requestData),
    ...args
  );
};

apiDataPropertyListByDeviceTypeRulesIdGet.requestConfig = apiDataPropertyListByDeviceTypeRulesIdGetRequestConfig;

/* prettier-ignore-end */
